if (!customElements.get('gm-economic-dashboard')) {
 class GMEconomicDashboard extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();
   this.controller = new AbortController();
   const signal = this.controller.signal;
   this.addEventListener('click', event => {
    const target = event.target.closest('button');
    if (!target || !this.contains(target)) return;
    if (target.dataset.language) this.setLanguage(target.dataset.language, true);
    if (target.hasAttribute('data-fullscreen')) this.toggleFullscreen();
   }, { signal });
   document.addEventListener('fullscreenchange', () => this.updateFullscreen(), { signal });
   let preferred = this.dataset.defaultLanguage || 'en';
   try { preferred = localStorage.getItem('gm-research-language') || preferred; } catch {}
   const queryLanguage = new URL(location.href).searchParams.get('research_lang');
   this.setLanguage(queryLanguage || preferred, false);
   this.updateClock();
   if (this.dataset.tv === 'true') this.clockTimer = setInterval(() => this.updateClock(), 60000);
  }
  disconnectedCallback() { this.controller?.abort(); clearInterval(this.clockTimer); }
  setLanguage(language, persist) {
   language = language === 'fa' ? 'fa' : 'en';
   this.lang = language === 'fa' ? 'fa-AF' : 'en';
   this.dir = language === 'fa' ? 'rtl' : 'ltr';
   this.querySelectorAll('[data-research-lang]').forEach(el => el.hidden = el.dataset.researchLang !== language);
   this.querySelectorAll('[data-language]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.language === language)));
   this.querySelector('[data-language-label]')?.setAttribute('aria-label', language === 'fa' ? 'زبان پژوهش' : 'Research language');
   this.querySelector('nav')?.setAttribute('aria-label', language === 'fa' ? 'راهبری پژوهش' : 'Research navigation');
   if (this.dataset.tv === 'true') { document.documentElement.lang = this.lang; document.documentElement.dir = this.dir; }
   if (persist) {
    try { localStorage.setItem('gm-research-language', language); } catch {}
    const url = new URL(location.href);
    url.searchParams.set('research_lang', language);
    history.replaceState(history.state, '', url);
   }
   this.updateResearchLinks(language);
   this.updateClock();
  }
  updateResearchLinks(language) {
   const current = new URL(location.href);
   this.querySelectorAll('[data-tv-link]').forEach(link => {
    const url = new URL(link.href);
    url.searchParams.set('research_lang', language);
    for (const key of ['preview_theme_id', 'pb']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    link.href = url.href;
   });
  }
  updateClock() {
   const clock = this.querySelector('[data-device-clock]');
   if (!clock) return;
   const now = new Date();
   clock.dateTime = now.toISOString();
   clock.textContent = new Intl.DateTimeFormat(this.lang, { dateStyle: 'medium', timeStyle: 'short' }).format(now);
  }
  updateFullscreen() {
   const button = this.querySelector('[data-fullscreen]');
   if (!button) return;
   const active = document.fullscreenElement === this;
   button.setAttribute('aria-pressed', String(active));
   const texts = this.querySelectorAll('[data-fullscreen] [data-research-lang]');
   texts.forEach(el => el.textContent = el.dataset.researchLang === 'fa' ? (active ? 'خروج از تمام‌صفحه' : 'تمام‌صفحه') : (active ? 'Exit full screen' : 'Full screen'));
  }
  async toggleFullscreen() {
   try {
    if (document.fullscreenElement) await document.exitFullscreen();
    else await this.requestFullscreen();
   } catch {
    this.querySelector('[data-research-status]').textContent = this.dir === 'rtl' ? 'تمام‌صفحه در این قاب در دسترس نیست. پیوند تلویزیون را در زبانهٔ جدا باز کنید.' : 'Full screen is unavailable here. Open the TV preview in its own tab.';
   }
  }
 }
 customElements.define('gm-economic-dashboard', GMEconomicDashboard);
}

